import styled from "styled-components";

export const Navbar = styled.div`
 padding: 0  50px;
height: 80px;
 background: #FFFFFF;
/* border: 0.7px solid #EEEEEE; */
color: black;
font-family: 'Inter';
font-weight: 400;
font-size: 14px;
line-height: 24px;
display: flex;
flex-direction: row;
align-items: center;
text-align: center;
justify-content: space-between;

.nav__row{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;

  .nav__list{
  padding: 0px 40px ;
  list-style: none;
  display: flex;
  text-align: center;
  color: ${props => props.primary ? '#377DFF' : 'black'};
    .nav__item{
       
        padding: 0px 30px;

        &:hover{
            cursor: pointer;
            color: #377DFF
        }
    }
  }
  .nav__btn{
    display: flex;
  }
 
}

@media (max-width: 790px) {
  
  font-weight: 100;
  font-size: 14px;
  line-height: 10px;
  flex-grow: 1;
  }
  

`

